export const mainBannerIndustriales = [
    {
        image: '/assets/imgs/services/industriales/fondo.png',
        color: '#1226AA',
        text: 'SERVICIOS<br/><span>INDUSTRIALES</span>',
      }

];

export const mainBannerIndustrialesEn = [
    {
        image: '/assets/imgs/services/industriales/fondo.png',
        color: '#1226AA',
        text: '<h5>INDUSTRIAL</h5><h3>SERVICES</h3>',
      }
];